!(function (modObj) {

    var __symbolPrefix = "3r/login-api/registration-checks/"

    modObj.validated = function (Promise, Device) { 
        let isRegistered = (Device.thrid && Device.info && Device.info.user) && (Device.info.user.data.skipRegistration || (Device.info.user.ATTRIBUTES.validated && ! Device.info.user.mustLogin && Device.variables.enteredDetails))

        return Promise.resolve(isRegistered)
    }
    modObj.validated._depends = {
        symbol : __symbolPrefix + "validated",
        modules : [
            "Promise",
            "3r/Device"
        ]
    }

    modObj.externalId = function (_, Promise, Device, externalIdParameter, schemeSettings) {
        let paramExternalId = externalIdParameter(schemeSettings)
        if (!paramExternalId) {
            return Promise.resolve(true)
        }

        let externalId = _.get(Device,"info.user.ATTRIBUTES.externalId",false)

        if (paramExternalId && externalId) {
            return Promise.resolve(paramExternalId == externalId)
        } else {
            return Promise.resolve(true)
        }
    }

    modObj.externalId._depends = {
        symbol : __symbolPrefix + "externalId",
        modules : [
            "_",
            "Promise",
            "3r/Device",
            "3r/externalIdParameter",
            "3r/schemeSettings/webapp"
        ]
    }

    if (typeof window == "object" && window.ioc) {
        ioc.injectAll(modObj)
    }

    return modObj
})(typeof exports == "object" ? exports : {})
/* This comment tricks JSPM into wrapping the file as CommonJs module.
exports.fake
*/